<template>
    <div class="project-types-potential">
        <div class="placeholder">
            <div class="placeholder__heading">
                Potentielt ekstra årligt EBITDA pr. opgavetype
                <d-tooltip placement="inline" identifier="potential.projectTypePotential" />
            </div>
            
            <div class="placeholder padding" v-if="projectTypes && !loading">
                <div class="intro">
                    Her ser du, hvad det giver i øget årligt EBITDA, at øge prisen med få procent.
                </div>
                <div class="list" v-if="projectTypes.length > 0">
                    <div class="single" v-for="projectType in projectTypes" :key="projectType.name">
                        <div class="info">
                            <strong>
                                {{ projectType.name }}
                            </strong>
                            <div class="small">
                                <b>{{ projectType.projects_count }}</b>
                                opgaver m. samlet omsætning på
                                <b>{{ projectType.total_revenue | currency }}</b>
                                <br>
                                Gns. DG pr. opgave: <b>{{ projectType.coverage_percent | number }}%</b>
                                <!--<br>
                                <i>≈ {{ projectType.total_revenue * convertToYear | currency }} årligt</i>-->
                            </div>
                        </div>
                        <div class="slider">
                            <div v-if="projectType.total_revenue > 0">
                                <input type="range" :min="-100" :max="100" v-model="projectType.value" />
                                <br>
                                <div class="slider-value">
                                    <div class="small" style="display:flex;justify-content:space-between;">
                                        <div>
                                            Meromsætning
                                        </div>
                                        <div>
                                            <span v-if="projectType.value > 0">+</span>{{ projectType.value }} %
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="small" align="center">
                                Ingen data for perioden
                            </div>
                        </div>
                        <div class="result" :class="{'positive': (projectType.total_revenue / 100) * projectType.value > 0, 'negative': (projectType.total_revenue / 100) * projectType.value < 0}">
                            <div v-if="projectType.total_revenue > 0 && projectType.value !== 0 && projectType.value !== '0'">
                                <span v-if="projectType.value > 0">+</span>{{ ((projectType.total_revenue / 100) * projectType.value * convertToYear ) | currency }}
                            </div>
                            <div v-else>
                                -
                            </div>
                        </div>
                    </div>
                    <div class="single">
                        <div class="info big">
                            Potentielt ekstra årligt EBITDA
                        </div>
                        <div class="slider">
                            
                        </div>
                        <div class="result big" :class="{'positive': total > 0, 'negative': total < 0}">
                            <span v-if="total > 0">+</span>{{ total | currency }}
                        </div>
                    </div>
                </div>
            </div>

            <box-loading height="350" v-else />

        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .intro {
        font-size: $fontsize--main * 1.2;
        margin-bottom: $margin--main;
        text-align: center;
    }

    .list {

        .single {
            display: flex;
            align-items: center;
            padding: 15px 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            font-family: $fontfamily--main;

            &:first-of-type {
                padding-top: 0px;
            }

            &:last-of-type {
                border: none;
                padding: 30px 0 15px 0;
            }

            .small {
                font-size: 14px;

                b {
                    font-weight: 600;
                }
            }

            .info {
                flex: 0 0 50%;

                &.big {
                    font-weight: 700;
                    font-size: 20px;
                }

                strong {
                    font-weight: 600;
                    color: $color--dark;
                    margin-bottom: 10px;
                    display: block;
                }
            }

            .slider {
                flex: 0 0 25%;

                .slider-value {
                    text-align: center;
                }
            }

            .result {
                flex: 0 0 25%;
                font-weight: 600;
                font-size: 24px;
                text-align: center;

                &.big {
                    font-size: 30px;
                    font-weight: 700;
                }

                &.positive {
                    color: $color--good;
                }

                &.negative {
                    color: $color--bad;
                }
            }
        }
    }

</style>

<script>
import * as calculationService from '@/services/calculationService'
import moment from 'moment'

export default {
    data () {
        return {
            loading: true,
            projectTypes: []
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            calculationService.projectTypesPotential(params, (response) => {
                if (this.projectTypes.length > 0) {
                    response.data.forEach((responseType) => {
                        this.projectTypes.forEach((projectType) => {
                            if (projectType.name === responseType.name) {
                                responseType.value = projectType.value
                            }
                        })
                    })
                }
                this.projectTypes = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        total () {
            if (this.projectTypes.length > 0) {
                let total = 0
                this.projectTypes.forEach((projectType) => {
                    let value = (projectType.total_revenue / 100) * projectType.value
                    total += value
                })
                return total * this.convertToYear
            }
        },
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        },
        convertToYear () {
            let startDate = moment(this.$store.getters.getStartDate)
            let endDate = moment(this.$store.getters.getEndDate)
            if (endDate > moment()) {
                endDate = moment()
            }
            let duration = moment.duration(endDate.diff(startDate))
            let days = duration.asDays() + 1
            return 365 / days
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// projectTypesPotential.vue?7ae4dbe1